import { parseDay } from '../../utils/dateTypes';
import { DaySequenceBinaryProps } from './types';
import { calculateTotalDays } from './utils';

export interface ValidationResult {
  isValid: boolean;
  error?: string;
}


/**
 * Validates DaySequenceBinary component props
 */
export const validateDaySequenceBinaryProps = ({
  startDate,
  endDate,
  eventDates
}: Pick<DaySequenceBinaryProps, 'startDate' | 'endDate' | 'eventDates'>): ValidationResult => {
  const start = parseDay(startDate);
  const end = parseDay(endDate);

  // Check if start date is before or equal to end date
  if (start > end) {
    return {
      isValid: false,
      error: `DaySequenceBinary: Start date (${startDate}) must be before or equal to end date (${endDate}).`
    };
  }

  const totalDays = calculateTotalDays(startDate, endDate);

  // Check minimum range
  if (totalDays < 7) {
    return {
      isValid: false,
      error: `DaySequenceBinary: Date range too small (${totalDays} days). Minimum is 7 days.`
    };
  }

  // Check maximum range
  if (totalDays > 366) {
    return {
      isValid: false,
      error: `DaySequenceBinary: Date range too large (${totalDays} days). Maximum is 366 days.`
    };
  }

  // Validate event dates are within range
  const eventDateObjects = eventDates.map(parseDay);
  const invalidEvents = eventDateObjects.filter(eventDate => eventDate < start || eventDate > end);

  if (invalidEvents.length > 0) {
    return {
      isValid: false,
      error: `DaySequenceBinary: ${invalidEvents.length} event date(s) are outside the specified date range.`
    };
  }

  return {
    isValid: true
  };
};